<template>
  <section class="gallery">
    <div class="tag-desc">
      <h4 class="txt-normal">Conheça um pouco dos</h4>
      <h2 class="title">Nossos Serviços</h2>
    </div>
    <ul class="">
        <router-link class="populated" :to="`/${slide.titulo.replaceAll(' ','-').toLowerCase()}/`" v-for="(slide) in slides" v-bind:key="slide.titulo" v-bind:style="{ backgroundImage: `linear-gradient(180deg,#00000000 54%, #f42f03 79%), url(${slide.Img})`, backgroundSize: 'cover',backgroundPosition: 'center center',backgroundRepeat: 'no-repeat' }"> <h4 class="titulo">{{ slide.titulo }}</h4></router-link>
    </ul>
  </section>
</template>
<script>
export default {
  name: 'servicos-cps',
  data () {
    return {
      slides: [
        {
          titulo: 'Guincho Para Carros',
          sub: 'Guincho 24 Horas',
          Img: require('@/assets/i01.webp')
        },
        {
          titulo: 'Guincho Para Motos',
          sub: 'Guincho 24 Horas',
          Img: require('@/assets/i02.webp')
        },
        {
          titulo: 'Guincho Para vans',
          sub: 'Guincho 24 Horas',
          Img: require('@/assets/i03.webp')
        },
        {
          titulo: 'Guincho Para Equipamentos',
          sub: 'Guincho 24 Horas',
          Img: require('@/assets/i08.webp')
        },
        {
          titulo: 'Guincho Para Carros Antigos',
          sub: 'Guincho 24 Horas',
          Img: require('@/assets/i05.webp')
        },
        {
          titulo: 'Guincho Para Empilhadeiras',
          sub: 'Guincho 24 Horas',
          Img: require('@/assets/i06.webp')
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
/* * {
  max-width: 100% !important
} */
/* section {
  margin: 7rem 0 !important;
} */

/* img,
span {
  vertical-align: middle;
} */
.gallery {
  margin-bottom: 200px!important;
  .populated {
    padding: 10px 0px 10px 0px;
}
  ul {
    // padding: 2px !important;
    // display: grid;
    // gap: 6px;
    // grid-template-columns: repeat(5, calc((80vw - 9px)/5));
    display: flex;
    position: relative;
    width: 100%;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 6px;

    a {
      width: 16%;
      @media only screen and (max-width: 600px) {
            width: 100%;
    }
      height: 400px;
      background-size: 100% 100%;
      object-fit: fill;
      display: flex;
      align-items: left;
      justify-content: flex-end;
      flex-direction: column;
      padding-bottom: 1rem !important;

      .titulo {
        min-width: 80%!important;
        max-width: 80%!important;
        font-size: 1.2vw;
        text-align: left;
        @media only screen and (max-width: 600px) {
          font-size: 6vw;
        }
        font-family: "Teko", Sans-serif;
    font-size: 23px;
    font-weight: 500;
    text-transform: uppercase;
        color: #fff !important
      }

      .sub {
        background: #000;
        --e-column-margin-left: 15px;
        text-align: left;
        color: #f42e03 !important
      }

      color:#fff !important
    }

    @media only screen and (max-width: 600px) {
      grid-template-columns: repeat(2, calc((90vw - 6px)/2))
    }
  }
}

.bck-overlay {
  padding: 1rem !important;
  background-color: orange;
  opacity: 0.81;
}

button.b2 {
  background: #16153D;
}

button {
  margin: 4px;
  border: 0;
  border-radius: 50px;
  padding: .75rem 2.75rem;
  color: #fff;
  box-shadow: 0 .5rem 1.5rem rgba(0, 0, 0, .25);
  cursor: pointer;
  position: relative;
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 1px;
  -webkit-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;

  &:hover {
    -webkit-transform: translateY(-5px);
    -ms-transform: translateY(-5px);
    -o-transform: translateY(-5px);
    transform: translateY(-5px);
    box-shadow: 0 1rem 1.5rem rgba(0, 0, 0, .25);
  }
}
</style>
